"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedOnly = EmbedOnly;
const jsx_runtime_1 = require("react/jsx-runtime");
const embed_context_provider_1 = require("./embed-context-provider");
function EmbedOnly({ children, names }) {
    const embed = (0, embed_context_provider_1.useEmbed)();
    if (!embed.isEmbed) {
        return null;
    }
    if (!names) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    const targetEmbeds = [names].flat();
    const shouldShow = targetEmbeds.includes(embed.name);
    return shouldShow ? children : null;
}
